import React from "react";
import Header from "../../layout/Header";
import { motion } from "framer-motion"; // Animate text in smoothly, left-to-right

const BannerContent = ({
  bannerImage,
  title,
  subtitle,
  containerStyles = {},
  bannerHeight,
  titleStyles = {},
}) => {
  // Use fixed banner height
  const heightValue = "540px";

  // Animation variants for staggered, smooth left-in effect
  const parentVariants = {
    initial: {},
    animate: {
      transition: {
        staggerChildren: 0.28,
      },
    },
  };

  const textLeftFadeIn = {
    initial: { opacity: 0, x: -60 },
    animate: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.85, ease: [0.4, 0, 0.2, 1] },
    },
  };

  const styles = {
    wrapper: {
      overflow: "hidden",
      padding: 0,
      ...containerStyles,
    },
    banner: {
      position: "relative",
      marginTop: "10px",
      width: "100%",
      minHeight: heightValue,
      height: heightValue,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
    },
    image: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      zIndex: 1,
      minHeight: heightValue,
      maxHeight: heightValue,
    },
    title: {
      margin: 0,
      fontWeight: 800,
      fontSize: "4.5rem",
      lineHeight: 1.2,
      borderRadius: "12px",
      letterSpacing: "1px",
      display: "inline-block",
      maxWidth: "90vw",
      textShadow:
        "0px 4px 44px rgba(0,0,0,0.55), 0px 3px 10px rgba(27,62,111,0.23), 0px 10px 60px rgba(0,0,0,0.27)",
      color: "#fff",
      fontFamily: "'Poppins', sans-serif",
      ...titleStyles,
    },
    subtitle: {
      color: "#fff",
      fontSize: "1.7rem",
      marginTop: "14px",
      fontWeight: 600,
      letterSpacing: "1.2px",
      textShadow: "0px 3px 20px rgba(0,0,0,0.37)",
      fontFamily: "gilroy, sans-serif",
    },
  };

  return (
    <div style={styles.wrapper}>
      <Header />
      <div style={styles.banner} className="relative w-full h-full">
        {bannerImage && (
          <img
            src={bannerImage}
            alt="Banner"
            style={styles.image}
            className="w-full h-full object-cover absolute inset-0 z-0"
          />
        )}
        <div
          className="relative z-10 flex items-center h-full w-full max-w-screen-xl mx-auto"
          style={{ height: "100%" }}
        >
          <motion.div
            className="flex flex-col justify-center items-start h-full pl-8 sm:pl-12"
            style={{
              height: "100%",
              width: "66.666%",
              maxWidth: "66.666%",
              flexBasis: "66.666%",
            }}
            variants={parentVariants}
            initial="initial"
            animate="animate"
          >
            <motion.h6 style={styles.title} variants={textLeftFadeIn}>
              {title}
            </motion.h6>
            {subtitle && (
              <motion.div style={styles.subtitle} variants={textLeftFadeIn}>
                {subtitle}
              </motion.div>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default BannerContent;
